import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"

import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {H2, H4} from "@irati/ui/src/Typography"
import DragAndDrop from "@irati/ui/src/DragAndDrop"
import Flex from "@irati/ui/src/Flex"

import {CircledConnector} from "./styled"
import FieldsRecap from "./FieldsRecap"
import DownloadCsvTemplate from "./DownloadCsvTemplate"

interface Props extends InjectIntl {
  onDrop: (acceptedFiles?: any[]) => void
  back: () => void
}

class AddPeopleCSV extends Component<Props> {
  render() {
    const {onDrop, formatMessage} = this.props

    return (
      <Flex justifyContent="flex-start" direction="column">
        <H2 marginBottom={4}>
          <FormattedMessage id="admin.components.addPeopleCSV.headerTwo" />
        </H2>
        <H4 marginBottom={2}>
          <FormattedMessage id="admin.components.addPeopleCSV.headerFour.text" />
        </H4>
        <CircledConnector
          data={[
            "renderCompFromProps",
            formatMessage({id: "admin.components.addPeopleCSV.circledConnector.data.fillInformation"}),
            formatMessage({id: "admin.components.addPeopleCSV.circledConnector.data.dragAndDrop"})
          ]}
          comp={<DownloadCsvTemplate />}
        />
        <Row>
          <Col md={12}>
            <DragAndDrop onDrop={onDrop} />
            <FieldsRecap addUsers />
          </Col>
        </Row>
      </Flex>
    )
  }
}

export default injectIntl(AddPeopleCSV)
